import Link from 'next/link'
import Image from 'next/image'

import Modal from './Modal'
import CustomModal from './CustomModal'
import * as Styles from './style'
import { FlexCol, FlexRow } from 'styles/styled'
import Loader from '../loader'
import { formatAddress } from 'shared/helpers'
import LinkSVG from 'public/assets/gallery/link.svg'
import { getConfig } from 'config'
import { useAppSelector } from 'src/logic/redux/hooks'
import { TransactionEnum } from 'src/logic/redux/slices/nftsSlice'

import { CloseSvg, ErrorIcon, TickSvg } from 'shared/images'
import { WalletTypeEnum } from 'src/logic/redux/slices/userSlice'

const StatusModal = (props: any) => {
  const { handleClose, onBtnClick, show } = props

  const { transactionStatus, transactionHash, transactionMessage } =
    useAppSelector((state) => state.nftReducer)
  const { user } = useAppSelector((state) => state.userReducer)

  const icon =
    transactionStatus === TransactionEnum.SUCCESS
      ? TickSvg
      : transactionStatus === TransactionEnum.ERROR
      ? ErrorIcon
      : ''

  const heading =
    transactionStatus === TransactionEnum.STARTED
      ? user?.walletType === WalletTypeEnum.CUSTODIAL_WALLET
        ? 'Processing Transaction'
        : 'Confirm in Wallet'
      : transactionStatus === TransactionEnum.HASH
      ? 'Confirming on Chain'
      : transactionStatus === TransactionEnum.SUCCESS
      ? 'Confirmed'
      : 'Error!'

  const info =
    transactionStatus === TransactionEnum.STARTED
      ? user?.walletType === WalletTypeEnum.CUSTODIAL_WALLET
        ? 'Processing Transaction'
        : 'Confirm the transaction in your wallet.'
      : ''

  return (
    <CustomModal show={show} handleClose={handleClose} className='status-modal'>
      <Modal onBtnClick={onBtnClick} hideBtn={true}>
        <Styles.InfoModalContainer className='status'>
          <FlexCol gap='24px'>
            {icon ? (
              <Styles.ImageCont>
                <Image src={icon} alt='welcome-icon' />
                <Image
                  src={CloseSvg}
                  alt='close-icon'
                  className='close'
                  onClick={handleClose}
                />
              </Styles.ImageCont>
            ) : (
              <Loader />
            )}

            <FlexCol gap='12px' alignItems='center' className='status-text'>
              <h4>{heading}</h4>
              <p>{info}</p>
            </FlexCol>

            <FlexCol
              alignItems='stretch'
              className='transaction-status'
              gap='8px'
            >
              <FlexRow justifyContent='space-between'>
                <p>Status</p>

                <h4 className={transactionStatus === 'ERROR' ? 'error' : ''}>
                  {transactionMessage}
                </h4>
              </FlexRow>

              <FlexRow justifyContent='space-between'>
                {transactionHash && <p>Transaction</p>}
                {transactionHash && (
                  <Link
                    href={getConfig().polygonscanUrl + transactionHash}
                    target='_blank'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '14px',
                    }}
                  >
                    <h4>{formatAddress(transactionHash)}</h4>
                    <Image src={LinkSVG} alt='link-icon' />
                  </Link>
                )}
              </FlexRow>
            </FlexCol>
          </FlexCol>
        </Styles.InfoModalContainer>
      </Modal>
    </CustomModal>
  )
}

export default StatusModal
